export const pluralizationRulesRu = (choice_: number, choicesLength: number) => {
  if (choice_ < 0) {
    return 0
  }

  if (choicesLength === 2) {
    return (choice_ % 10 === 1 && choice_ % 100 !== 11) ? 0 : 1
  }

  if (choicesLength < 4) {
    return choice_
  }

  const choice = Math.abs(choice_)
  const teen = (choice % 100 > 10) && (choice % 100 < 20)
  const endsWithOne = choice % 10 === 1

  if (!teen && endsWithOne) {
    return 1
  }

  if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
    return 2
  }

  return 3
}
